import ComingSoon from "../components/ComingSoon";

const Learning = () => {
  return <ComingSoon />;
};

export default Learning;
